export const paintRegionsOptions = [
  { id: 1, label: 'Outlined', value: 'paintBlockOutline' },
  { id: 2, label: 'Filled', value: 'paintBlockFilled' },
];

// defectPermissionVisibility field is used to describe that this specific option is related to read:defects permissions
export const heatmapPropertiesDetails = [
  {
    id: 1,
    label: 'Paint Block',
    value: 'block',
    defectVisibilityPermission: false,
  },
  {
    id: 2,
    label: 'Detailed (Voxel)',
    value: 'voxel',
    defectVisibilityPermission: true,
  },
];

export const heatmapPropertiesValues = [
  {
    id: 1,
    label: 'Substrate Condition (Max)',
    value: 'substrateConditionMax',
    defectVisibilityPermission: true,
  },
  {
    id: 2,
    label: 'Coating Condition (Max)',
    value: 'coatingConditionMax',
    defectVisibilityPermission: true,
  },
  {
    id: 3,
    label: 'Trace',
    value: 'trace',
    defectVisibilityPermission: false,
  },
  {
    id: 4,
    label: 'Defects',
    value: 'defects',
    defectVisibilityPermission: true,
  },
];
